import { resolveSpotTabParam } from '@/domain/spot/spotTabQuery'
import { SpotListPage } from '@/features/pages/spots'
import type { NextPage } from 'next'
import { useRouter } from 'next/router'

/** v1の後方互換のためだけに作成。2027年6月以降に削除可能か確認する */
const SpotPage: NextPage = () => {
  const router = useRouter()
  // router.isReady を待たずに描画する。待つとプリレンダーした HTML（ヘッダー・スケルトン）が空になり、
  // クエリなしのフルロードではサーバー描画（isReady=false）と初回クライアント描画（isReady=true）が食い違う。
  // query 確定前は 0（マップ）になり、確定までの表示はページ側がスケルトンで吸収する（#3665）
  return <SpotListPage queryTab={resolveSpotTabParam(router.query.tab)} />
}

export default SpotPage

export { getStaticPaths, getStaticProps } from '@/core/app/getStaticFunctions'
